import {Injectable} from '@angular/core';
import {FilterFormatter} from '../../common/filters/filter-formatter';
import {ServerInfoService} from '../../common/services/server-info.service';
import {SessionService} from '../../common/services/session.service';

@Injectable({providedIn: 'root'})
export class QoeFilterFormatter extends FilterFormatter {

    constructor(private sessionService: SessionService) {
        super({
            setFilter: (resultFilterObject, filterObject, callingApi, saveToFile) => {
                this.setFilter(resultFilterObject, filterObject, callingApi);
            },
            setFilterForDynamicTab: (resultFilterObject, filterObject, callingApi) => undefined,
        });
    }

    setFilter = (resultFilterObject, filterObject, callingApi) => {
        const analyticsFilter = callingApi === 'analytics';
        const liveStatsPages = ['serviceQoe', 'customerQoe', 'userLocation'].includes(callingApi);
        const specificIntervalsStatsPages = ['serviceQoe', 'customerQoe', 'teamsDevice', 'ACLDevice'].includes(callingApi);//gennady and leonid asked in a call with me and miki to change entityId to id incase of devicesIntervals\servicesIntervals\customerIntervals

        if (!['customerQoe', 'serviceQoe', 'teamsDevice', 'ACLDevice'].includes(callingApi) && !analyticsFilter) {
            resultFilterObject.topology = callingApi === 'userLocation' ? 'location' : callingApi;
        }
        this.addTopologyOrServiceGroupIdsFilter(filterObject, resultFilterObject);
        if (callingApi === 'userLocation') {
            this.addArrayFilterParameter(filterObject, 'userLocations', resultFilterObject, 'locations', 'adFilters');
        }
        if(!liveStatsPages && (!ServerInfoService.oneLiveMode || (ServerInfoService.oneLiveMode && this.sessionService.activeSession?.isSystemOperator))){
            this.addTopologyFilter(filterObject, resultFilterObject, {
                excludeTenant: analyticsFilter,
                entities: analyticsFilter ? ['device'] : ['device', 'link', 'site'],
                filterName: (analyticsFilter && 'deviceId') || (specificIntervalsStatsPages && 'id'),
            });
        }

        const entitiesList = this.getLiveCloudEntityList(callingApi);
        this.addLiveCloudTopologyFilter(filterObject, resultFilterObject, callingApi, entitiesList, true);

        this.addTimeAndDateFilter(filterObject, resultFilterObject, analyticsFilter ? 'callEndTime' : 'timestamp');
    };

    private getLiveCloudEntityList = (callingApi) => {
        let entitiesList = ['channel', 'lcCustomer', 'service', 'link'];

        if(callingApi.toLowerCase().includes('device')) {
            entitiesList = ['channel', 'lcCustomer', 'service', 'device'];
        }else if(callingApi.includes('customerQoe')){
            entitiesList = ['channel', 'lcCustomer'];
        } else if(callingApi.includes('serviceQoe')){
            entitiesList = ['channel', 'lcCustomer', 'service'];
        }

        return entitiesList;
    };


    private addTopologyFilter = (filterObject, resultFilterObject, {excludeTenant = false, entities, filterName}: {excludeTenant: boolean; entities: string[]; filterName: string}) => {
        const statisticsTopologyFilter = filterObject && filterObject.Topology;

        if (statisticsTopologyFilter) {
            !excludeTenant && this.assignToFieldIfArray({resultFilterObject, field: 'tenantId', array: statisticsTopologyFilter.tenant});
            this.assignToFieldIfArray({resultFilterObject, field: 'regionId', array: statisticsTopologyFilter.region});

            const currentTopology = resultFilterObject.topology?.toLowerCase();

            entities.forEach((entity) => {
                filterName = filterName || 'entityId';
                if (currentTopology !== 'site' && entity === 'site') {
                    filterName = 'siteId';
                }

                if (statisticsTopologyFilter[entity] && statisticsTopologyFilter[entity].length > 0) {
                    resultFilterObject[filterName] = resultFilterObject[filterName] || [];
                    resultFilterObject[filterName].push.apply(resultFilterObject[filterName], statisticsTopologyFilter[entity].map((entity) => entity.id));
                }
            });
        }
    };
}
